<template>
  <v-card color="primary" :to="to" flat tile class="item">
    <v-img
      @error="imgError"
      :src="files + img + '?resize=1&w=400'"
      :alt="title"
      height="220px"
    ></v-img>

    <div class="pelicula"></div>

    <v-card-title class="title text-center d-flex justify-center">
      {{ title }}
    </v-card-title>
  </v-card>
</template>

<script>
import DefaultImg from "../../assets/img/default-img.png";

export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
  methods: {
    imgError(e) {
      e.target.src = DefaultImg;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  position: relative;

  & .title {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: var(--v-primary-base);
    color: #ffffff;
    font-size: 20px;
    font-weight: 500;
    padding: 5px 10px;
    min-height: 64px;
    z-index: 2;
    transition: ease 0.5s;
  }

  & .pelicula {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: var(--v-primary-base);
    opacity: 0.5;
    transition: ease 0.5s;
  }

  &:hover {
    & .pelicula {
      opacity: 0;
    }
    & .title {
      background-color: var(--v-secondary-base);
    }
  }
}

@media (max-width: 767px) {
  .item {
    & .title {
      font-size: 14px !important;
    }
  }
}
</style>
